"use client";
import { jsx as o } from "react/jsx-runtime";
import * as a from "@radix-ui/react-hover-card";
import { forwardRef as e } from "react";
const l = (r) => /* @__PURE__ */ o(a.Root, { "data-slot": "hover-card", ...r }), d = e((r, t) => /* @__PURE__ */ o(a.Trigger, { "data-slot": "hover-card-trigger", ...r, ref: t }));
d.displayName = "HoverCardTrigger";
const s = (r) => /* @__PURE__ */ o(a.Portal, { "data-slot": "hover-card-portal", ...r }), i = e((r, t) => /* @__PURE__ */ o(s, { children: /* @__PURE__ */ o(a.Content, { "data-slot": "hover-card-content", ...r, ref: t }) }));
i.displayName = "HoverCardContent";
const n = e((r, t) => /* @__PURE__ */ o(a.Arrow, { "data-slot": "hover-card-arrow", ...r, ref: t }));
n.displayName = "HoverCardArrow";
export {
  n as HoverCardArrow,
  i as HoverCardContent,
  s as HoverCardPortal,
  l as HoverCardRoot,
  d as HoverCardTrigger
};
